"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.function.name");
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _courseItem = _interopRequireDefault(require("@/components/courseItem.vue"));
var _winCourse = _interopRequireDefault(require("@/components/winCourse.vue"));
require("./index.less");
var _courseCard = _interopRequireDefault(require("@/components/courseCard/courseCard.vue"));
var _recommendCourse = require("@/api/recommendCourse");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CourseCard: _courseCard.default,
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    CourseItem: _courseItem.default,
    WinCourse: _winCourse.default
  },
  data: function data() {
    return {
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 20,
        flag: ''
      },
      list: [],
      menusList: [{
        tit: '课程状态',
        itemList: [{
          name: '全部',
          id: ''
        }, {
          name: '进行中',
          id: '2'
        }, {
          name: '即将开始',
          id: '1'
        }, {
          name: '已结束',
          id: '3'
        }],
        actheight: false,
        act: 0,
        isZhan: false,
        loading: false
      }]
    };
  },
  methods: {
    chooseList: function chooseList(e) {
      console.log('dianji', e);
      if (e[1].name == '全部') {
        this.query.flag = '';
      } else {
        this.query.flag = e[1].id;
      }
      this.query.pageNum = 1;
      this.getCourseList();
    },
    toSsearch: function toSsearch(e) {
      // console.log('dianji',e)
      this.query.keyWord = e.courseName;
      // this.query.keyWord = e.majorName
      this.getCourseList();
    },
    getCourseList: function getCourseList() {
      var _this = this;
      this.loading = true;
      (0, _recommendCourse.recommendList)(this.query).then(function (res) {
        _this.list = res.rows;
        _this.total = res.total;
        _this.loading = false;
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.query.pageNum = e;
      this.getCourseList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query.pageSize = e;
      this.query.pageNum = 1;
      this.getCourseList();
    }
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getCourseList();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }()
};